/*
 * @Author: Teemo Ding
 * @Date: 2021-08-31 17:38:15
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-09-03 21:49:00
 * @FilePath: /unifyxp-v2-store-portal/src/request/salesChannel/discounts/flashSale.ts
 */
import { post, get } from 'src/tools/server';

export const getFlashSale = (data, params) => {
  return post<any>(`/portal/discount/flashSale/list`, data, params || {});
};

export const getCurrency = (salesChannelUuid) => {
  return get<any[]>(
    `/portal/salesChannel/${salesChannelUuid}/primaryCurrencyCode`,
    {},
  );
};

export const saveFlashSale = (data) => {
  return post<any>(`/portal/discount/flashSale`, data, {});
};

export const initFlashSale = (salesChannelUuid) => {
  return get<any>(`/portal/discount/flashSale/${salesChannelUuid}/init`, {});
};

export const publishFlashSale = (flashSaleDiscountUuids) => {
  return post<any[]>(
    `/portal/discount/flashSale/publish`,
    { flashSaleDiscountUuids },
    {},
  );
};
export const toDraftFlashSale = (flashSaleDiscountUuids) => {
  return post<any[]>(
    `/portal/discount/flashSale/toDraft`,
    { flashSaleDiscountUuids },
    {},
  );
};

export const archiveFlashSale = (flashSaleDiscountUuids) => {
  return post<any[]>(
    `/portal/discount/flashSale/archive`,
    { flashSaleDiscountUuids },
    {},
  );
};

export const getFlashSaleDetail = (flashSaleDiscountUuid) => {
  return get<any>(`/portal/discount/flashSale/${flashSaleDiscountUuid}`, {});
};

export const flashSaleCheckName = (data) => {
  return post<any>(`/portal/discount/flashSale/checkName`, data, {});
};
